import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { UrlConnectionEnum } from 'src/app/enums/connection/url-connection.enum';
import { ResetPwdResponse } from 'src/app/models/auth-model/reset-pwd-response.model';
import { HttpService } from '../http-service/http.service';

@Injectable({
    providedIn: 'root'
})
export class ResetPwdService {

    constructor(private httpService: HttpService) { }

    /**
     * Resets user password by CPF
     * @author Starley Cazorla
     * @param cpf
     * @returns Promise<ResetPwdResponse>
     */
    async resetPwd(cpf: string): Promise<ResetPwdResponse> {
        const config = this.httpService.setHeaderConfig(false);
        return lastValueFrom<ResetPwdResponse>(this.httpService.post(UrlConnectionEnum.RESET_PWD, { cpf }, config));
    }

}
